// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__1Fo8y","fileBtn":"File_fileBtn__vVbEr","closeBtn":"File_closeBtn__2DbId","fileSelected":"File_fileSelected__3I123","disabled":"File_disabled__2yTl1"};